import React from "react";
import { WarningIcon } from "@assets/images";
import BaseModal from "@components/common/HPBaseModal";
import { ModalProps } from "@/_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface ForceUnlockDashboardModalProps extends ModalProps {
  lockedBy: string;
  onConfirm: () => void;
  loading?: boolean;
}

const ForceUnlockDashboardModal: React.FC<ForceUnlockDashboardModalProps> = ({
  lockedBy,
  onConfirm,
  loading,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  const handleConfirm = () => {
    onConfirm();
    closeTopModal();
  };

  return (
    <BaseModal
      title="Force Unlock Dashboard?"
      headerIcon={<WarningIcon />}
      message={
        <span>
          Are you sure you wish to remove the lock by <strong>{lockedBy}</strong>{" "}
          for this Dashboard?
        </span>
      }
      confirmButtonText="Force Unlock"
      cancelButtonText="Cancel"
      loading={loading}
      onConfirm={handleConfirm}
      onCancel={closeTopModal}
    />
  );
};

export default ForceUnlockDashboardModal;
